import { brandBeta, brandMark, brandWordmark } from '@lunary/ui-tokens'
import { BrandBetaBadge } from './brand-beta-badge'
import { isBrandBeta } from './brand-stage'

type Props = { height?: number; title?: string; beta?: boolean }

export function BrandWordmark({ height = 28, title = 'Lunary', beta = isBrandBeta() }: Props) {
  const viewBox = beta ? brandBeta.wordmark.viewBox : brandWordmark.viewBox
  const [, , w, h] = viewBox.split(' ').map(Number)
  const width = Math.round((height * (w ?? 1)) / (h ?? 1))
  return (
    <svg width={width} height={height} viewBox={viewBox} role="img" aria-label={beta ? `${title} бета` : title} fill="currentColor">
      <path d={brandMark.letter} />
      <path d={brandMark.moon} />
      <path d={brandMark.sparkLarge} />
      <path d={brandMark.sparkSmall} />
      <path d={brandWordmark.word} />
      {beta && <BrandBetaBadge {...brandBeta.wordmark} />}
    </svg>
  )
}
